import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../context/LangContext";
import { Instagram } from "lucide-react";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer data-testid="footer" className="bg-[#020202] border-t border-white/5 pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-16">
          <div className="md:col-span-5">
            <Link to="/" className="font-display text-2xl tracking-[0.25em] text-white">
              INTIMO<span className="text-[#00E5FF]">.</span>MODELS
            </Link>
            <p className="mt-5 text-neutral-500 text-sm leading-relaxed max-w-md">
              International casting agency for male underwear and intimate apparel campaigns. Premium brands. Premium production.
            </p>
            <div className="mt-6 flex items-center gap-3">
              <a href="#" className="w-10 h-10 border border-white/10 flex items-center justify-center text-neutral-500 hover:text-[#00E5FF] hover:border-[#00E5FF] transition-colors">
                <Instagram size={16} />
              </a>
            </div>
          </div>
          <div className="md:col-span-3">
            <div className="label-eyebrow mb-5">Agency</div>
            <ul className="space-y-3 text-neutral-400">
              <li><a href="#requirements" className="hover:text-[#00E5FF] transition-colors">{t.nav.requirements}</a></li>
              <li><a href="#how" className="hover:text-[#00E5FF] transition-colors">{t.nav.how}</a></li>
              <li><a href="#apply" className="hover:text-[#00E5FF] transition-colors">{t.nav.apply}</a></li>
              <li><Link to="/admin" className="hover:text-[#00E5FF] transition-colors">{t.nav.admin}</Link></li>
            </ul>
          </div>
          <div className="md:col-span-4">
            <div className="label-eyebrow mb-5">Legal</div>
            <ul className="space-y-3 text-neutral-400 text-sm">
              <li>{t.footer.terms}</li>
              <li>{t.footer.privacy}</li>
              <li>{t.footer.contact}: casting@intimomodels.com</li>
              <li>+18 — Adult Casting Only</li>
            </ul>
          </div>
        </div>
        <div className="pt-8 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-neutral-600 text-xs tracking-wider">© {new Date().getFullYear()} INTIMO MODELS. {t.footer.rights}</p>
          <p className="text-neutral-600 text-xs tracking-[0.25em] uppercase">Casting · Premium · Adults Only</p>
        </div>
      </div>
    </footer>
  );
}
